events.eventsCompetitionModule = {
    // Funkcia na otvorenie GoldenLeague
    goldenLeagueButton() {
        try {
            if (!profile.GoldenLeagueBlocked && profile.Club) {
                $("#sectionTop").addClass("ui-disabled");
                main.openPage('club');
                setTimeout(function () {
                    $("#sectionTop").removeClass("ui-disabled");
                    more.menu.clubPage(8);
                }, 500);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zmenu vizualu stranky GoldenLeague
    goldenLeagueRender(active) {
        try {
            if (active) {
                offer.goldenLeague = true;
                $("#offerTop").text(texts.OfferGoldenLeague);
                $("#tableTop").addClass("golden-league");
                $("#events #sectionTop").addClass("golden-league-top").attr("onclick", "events.eventsCompetitionModule.goldenLeagueButton()")
                    .html('<div class="golden-league-row1">' + texts.GoldenLeagueRow1
                        + '<div class="golden-league-jackpot"><div></div></div></div>'
                        + '<div class="golden-league-row2">' + texts.GoldenLeagueRow2 + '</div>'
                        + '<div class="golden-league-row3">' + texts.GoldenLeagueRow3 + '</div>');
                more.menu.clubStats("Competition-Expert", false);
            } else if (offer.goldenLeague) {
                offer.goldenLeague = false;
                $("#tableTop").removeAttr("class")
                $("#events #sectionTop").removeAttr("class").empty();
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zmenu vizualu stranky Jackpot
    jackpotGet(active) {
        try {
            if (profile.JackpotsBlocked) {
                return false;
            }
            if (active) {
                var connExists = false;
                if (offer.jackpotCodes && (connection.state === signalR.HubConnectionState.Connected)) {
                    connExists = offer.signalrView.some(function(sView) {
                        return sView.includes("jp_");
                    });
                }

                if (connExists && (cachedJackpot = service.dataCache("Jackpot", "LOAD")) && cachedJackpot.data) {
                    events.eventsCompetitionModule.jackpotRender(cachedJackpot.data);
                } else {
                    $.getJSON(requestUrl = url.ticket + "jackpot")
                        .done(function (data) {
                            if (data === Object(data)) {
                                data = data.filter(function(jackpot) {
                                    if ([offer.platform, "all"].includes(jackpot.BetPlatform) && profile.JackpotBetTypes.includes(jackpot.BetType)) {
                                        return jackpot;
                                    }
                                });
                                if (data && cache && cache["Jackpot"] && !data.ErrorType) {
                                    service.dataCache("Jackpot", "SAVE", data);
                                }
                                events.eventsCompetitionModule.jackpotRender(data);
                            }
                        })
                        .fail(function (jqXHR) {
                            jqXHR.requestUrl = requestUrl;
                            main.createLog(2, "TicketJackpot_Error", "# AJAX FAILED: " + JSON.stringify(jqXHR));
                            return false;
                        });
                }
            } else if (offer.jackpot) {
                events.eventsCompetitionModule.clearJackpots();
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na zobrazovanie jackpotov
    jackpotRender(data) {
        try {
            if (data) {
                offer.jackpotCodes = [];
                data = data.filter(function(jackpot) {
                    jackpot.jackpotCode = jackpot.JackpotCode;
                    offer.jackpotCodes.push("jp_" + jackpot.JackpotCode);
                    if (jackpot.BetType === "ALL" || (offer.page === "virtualGames" && jackpot.BetType === "VG") || (offer.page !== "virtualGames" && jackpot.BetType === "SPORTBOOK")) {
                        return jackpot;
                    }
                });
                if (data.length) {
                    offer.jackpot = true;
                    stored.nTimesSuperBankCount = 4;
                    var jackpotElement = "";
                    $.each(data, function (j, jackpot) {
                        jackpotElement += "<div id=" + jackpot.JackpotCode.toLocaleLowerCase() + " class='jackpot-specific jackpot-" + j + " " + jackpot.jackpotCode + "'><div class='jackpot-inside'><div class='jackpot-label'>" + texts.JackpotLabel + "</div><div class='jackpot-value'>" + shared.floor2(jackpot.JackpotValue, 1) + " " + profile.Currency + "</div>";
                        if (profile.BonusList && jackpot.jackpotCode) {
                            if ((bonusIndexToOpen = more.menu.assignBonusSubPageMenu(profile.BonusList, "jackpot-" + jackpot.jackpotCode, "bonusName")) && bonusIndexToOpen !== -1) {
                                // Ak existuje podstranka k jackpotu tak vykresli klikatelne tlacitko na presmerovanie do bonusov
                                jackpotElement += "<span class='icon icon-info-circle' onmousedown='main.openPage(\"bonuses\", " + bonusIndexToOpen + ")'></span>";
                            }
                        }
                        jackpotElement += "</div></div>";
                    });
                    $("#tableJackpot #jackpotsWrapper").html(jackpotElement).removeClass().addClass(offer.country + " jackpot-times-" + (data.length >= stored.nTimesSuperBankCount? "n": "" + data.length));
                    $("#tableJackpot").show();
                    return true;
                } else {
                    events.eventsCompetitionModule.clearJackpots();
                    return false;
                }
            } else {
                events.eventsCompetitionModule.clearJackpots();
                return false;
            }
        } catch (e) {
            events.eventsCompetitionModule.clearJackpots();
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na vycistenie jackpotov
    clearJackpots() {
        offer.jackpot = false;
        $("#tableJackpot").hide();
        shared.scrollModule.scrollPage("jackpots", "left");
        $("#tableJackpot #jackpotsWrapper").empty().removeClass();
    }
};
